!(function () {
  let e = (e) =>
      !(function e(t) {
        if (t.length % 4 != 0 || !/^[A-Za-z0-9+/=]+$/.test(t)) return !1;
        try {
          return (atob(t), !0);
        } catch (r) {
          return !1;
        }
      })(e)
        ? e
        : decodeURIComponent(escape(window.atob(e))),
    t = {
      is_mark: 'F',
      shop_domain: window?.Shopify?.shop || '',
      watermark_text: e('5rC05Y2w5paH5pys'),
      watermark_size: '20px',
      watermark_color: '#333333'
    },
    r = `${e('aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms=')}?shop_domain=${t.shop_domain}`,
    i = () => {
      fetch(r).then((e) => {
        e.json().then((e) => {
          'success' === e.result &&
            ((t = { ...t, ...e, expire_time: Date.now() + 864e5 }),
            'T' === e.is_mark && n(t),
            localStorage.setItem('sitemark_watermark', JSON.stringify(t)));
        });
      });
    },
    s = null,
    n = (e) => {
      if (s) {
        s.disconnect();
        return;
      }
      let { watermark_text: t, watermark_size: r, watermark_color: i } = e,
        o = document.createElement('div');
      ((o.style.position = 'absolute'),
        (o.style.zIndex = '9999'),
        (o.style.left = '50%'),
        (o.style.bottom = '0'),
        (o.style.fontSize = r),
        (o.style.color = i),
        (o.innerHTML = t),
        setTimeout(() => {
          let t = document.querySelector('footer');
          t
            ? ((t.style.position = 'relative'),
              t.appendChild(o),
              (s = new MutationObserver((t) => {
                (s.disconnect(), (s = null), n(e));
              })).observe(t, { attributes: !0, childList: !0, subtree: !0 }))
            : ((o.style.position = 'fixed'), document.body.appendChild(o));
        }, 1e3));
    },
    o = localStorage.getItem('sitemark_watermark');
  if (o) {
    let a = JSON.parse(o);
    ((t = { ...t, ...a }),
      a.expire_time && a.expire_time < Date.now()
        ? i()
        : 'T' === a.is_mark && n(t));
  } else i();
})();

class YGBuyItNow extends HTMLElement {
  constructor() {
    super();
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.scheduledSync = null;
    this.syncRetries = 0;
  }

  connectedCallback() {
    this.triggerButton = this.querySelector('[data-buy-now-trigger]');
    if (!this.triggerButton) return;

    this.triggerButton.addEventListener('click', this.handleTriggerClick);
    this.ownerSection = this.closest('[id^="shopify-section-"]');
    if (this.ownerSection) {
      this.ownerSection.addEventListener(
        'variant:change',
        this.handleVariantChange
      );
      this.ownerSection.addEventListener(
        'bundle-changed',
        this.handleVariantChange
      );
    }

    this.scheduleSync();
  }

  disconnectedCallback() {
    if (this.triggerButton) {
      this.triggerButton.removeEventListener('click', this.handleTriggerClick);
    }
    if (this.ownerSection) {
      this.ownerSection.removeEventListener(
        'variant:change',
        this.handleVariantChange
      );
      this.ownerSection.removeEventListener(
        'bundle-changed',
        this.handleVariantChange
      );
    }
    if (this.scheduledSync) {
      window.cancelAnimationFrame(this.scheduledSync);
      this.scheduledSync = null;
    }
  }

  handleVariantChange() {
    this.syncRetries = 0;
    this.scheduleSync();
  }

  scheduleSync() {
    if (this.scheduledSync) return;
    this.scheduledSync = window.requestAnimationFrame(() => {
      this.scheduledSync = null;
      this.syncState();
    });
  }

  getNativePaymentButton() {
    const selectors = [
      '.shopify-payment-button .shopify-payment-button__more-options',
      '.shopify-payment-button .shopify-payment-button__button'
    ];
    for (const selector of selectors) {
      const candidate = this.querySelector(selector);
      if (!candidate) continue;
      const isDisabled =
        candidate.disabled ||
        candidate.getAttribute('aria-disabled') === 'true';
      if (!isDisabled) return candidate;
    }
    return null;
  }

  syncState() {
    if (!this.triggerButton) return;

    const nativePaymentWrapper = this.querySelector('.shopify-payment-button');
    const nativeButton = this.getNativePaymentButton();
    const wrapperHidden =
      !nativePaymentWrapper || nativePaymentWrapper.offsetParent === null;
    const shouldDisable = !nativeButton || wrapperHidden;

    this.triggerButton.disabled = shouldDisable;
    this.classList.toggle('is-disabled', shouldDisable);

    if (shouldDisable && this.syncRetries < 12) {
      this.syncRetries += 1;
      window.setTimeout(() => this.scheduleSync(), 120);
    } else if (!shouldDisable) {
      this.syncRetries = 0;
    }
  }

  handleTriggerClick(event) {
    event.preventDefault();
    const nativeButton = this.getNativePaymentButton();
    if (!nativeButton) {
      this.syncState();
      return;
    }
    nativeButton.click();
    this.syncRetries = 0;
    window.setTimeout(() => this.scheduleSync(), 120);
  }
}

if (!window.customElements.get('yg-buy-it-now')) {
  window.customElements.define('yg-buy-it-now', YGBuyItNow);
}
